/* app/js/src/components/common/navbar-menu/navbar-menu-item.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  cursor: pointer;
  color: #879baf;
  background-color: #232f3a;
}
:host:hover {
  color: #ffffff;
}
:host.enter {
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeInFromLeft;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease;
  -moz-animation-delay: 0s;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeInFromLeft;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -moz-animation-timing-function: ease;
  -o-animation-delay: 0s;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeInFromLeft;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  -o-animation-timing-function: ease;
  animation-delay: 0s;
  animation-duration: 0.2s;
  animation-name: fadeInFromLeft;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-timing-function: ease;
}
:host .menu-arrow {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
:host .menu-arrow.expanded {
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.label {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-bottom: 1px solid #2e3e4c;
  color: #879baf;
  font-size: 12px;
  line-height: 1em;
  padding: 1.5em;
}
.label:hover,
.label.active {
  background-color: #313e4b;
}
.keyboard-shortcut {
  font-size: 0.8em;
}
.inner-menu {
  display: block;
  background-color: rgba(49, 62, 75, 0.6);
  width: 100%;
  text-indent: 0.5em;
}
/*# sourceMappingURL=navbar-menu-item.component.css.map */
